<template>
  <div>
    <container-headline
      :headline="$t('global.detailsoflegalrepresentation')"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div
            class="form-check"
            style="padding-left: 36px"
            v-if="gesetzlicheVertretung.id && kontaktperson.id"
          >
            <input
              type="checkbox"
              v-model="wieKontaktperson"
              class="form-check-input"
              :disabled="!editable"
              @change="setGesetzlicheVertretungAufKontaktperson($event)"
            />
            <label>{{ $t("global.contactpersonislegalrepresentative") }}</label>
          </div>
          <div
            class="col-xl-12"
            v-if="!wieKontaktperson && gesetzlicheVertretung.id"
          >
            <div class="row">
              <div class="col-xl-6">
                <single-select-person
                  id="person"
                  :person="person"
                  :label="$t('global.person')"
                  :allowOpen="true"
                  :editable="true"
                  :required="false"
                  @confirmed="setPerson"
                />
              </div>
            </div>
            <div class="row" v-if="false">
              <div class="col-xl-6">
                <div class="form-group">
                  <input
                    v-model.trim="gesetzlicheVertretung.vorname"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.firstname") }}</label>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <input
                    v-model.trim="gesetzlicheVertretung.name"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.surname") }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xl-3">
                <input
                  v-model.trim="gesetzlicheVertretung.strasseNr"
                  type="text"
                  class="form-control"
                  placeholder=" "
                  :disabled="true"
                />
                <label>{{ $t("global.streetandhousenumber") }}</label>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <input
                    v-model.trim="gesetzlicheVertretung.plz"
                    type="text"
                    class="form-control"
                    placeholder=" "
                    :disabled="true"
                  />
                  <label>{{ $t("global.zipcode") }}</label>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <input
                    v-model.trim="gesetzlicheVertretung.ort"
                    type="text"
                    class="form-control"
                    placeholder=" "
                    :disabled="true"
                  />
                  <label>{{ $t("global.city") }}</label>
                </div>
              </div>
              <div class="form-group col-xl-3">
                <v-select
                  v-model.trim="gesetzlicheVertretung.land.id"
                  label="name"
                  :options="laender"
                  :placeholder="$t('global.country')"
                  :clearable="false"
                  :disabled="true"
                  :reduce="country => country.id"
                ></v-select>
                <label>{{ $t("global.country") }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.privatephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-private"
                      v-model="gesetzlicheVertretung.telefonP"
                      :disabled="true"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(gesetzlicheVertretung.telefonP)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.mobilephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-mobile"
                      v-model="gesetzlicheVertretung.telefonM"
                      :disabled="true"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(gesetzlicheVertretung.telefonM)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="gesetzlicheVertretung.beziehung.bezeichnung"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.relationshiptype") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <ValidationProvider
                    rules="email"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="gesetzlicheVertretung.email"
                      type="text"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :disabled="true"
                    />
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.email")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-check">
                  <input
                    type="checkbox"
                    v-model="gesetzlicheVertretung.einverstaendnisAuskunft"
                    class="form-check-input"
                    :disabled="true"
                  />
                  <label>{{ $t("global.consentinformation") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!gesetzlicheVertretung.id">
            {{ $t("global.nolegalrepresentation") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import AppApi from "@/api/AppApi";

export default {
  name: "GeschaeftspartnerGesetzlicheVertretungNewViva",
  components: {
    ContainerHeadline,
    SingleSelectPerson,
  },
  mixins: [],
  props: {
    gesetzlicheVertretung: {
      type: Object,
      default: function () {
        return {};
      },
    },
    kontaktperson: {
      type: Object,
      default: function () {
        return {};
      },
    },
    editable: {
      type: Boolean,
      required: true,
    },
    gpId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      person: {
        id: null,
        personName: null,
      },
      wieKontaktperson: false,
    };
  },
  computed: {
    inputOptions() {
      return { placeholder: this.$t("global.enteraphonenumber") };
    },
    laender() {
      if (this.$store) return this.$store.state.laender;
      return [];
    },
  },
  created() {},
  watch: {
    gesetzlicheVertretung: {
      handler(newVal) {
        this.person.id = newVal.id;
        this.person.personName = `${newVal.vorname} ${newVal.name}`;

        newVal.id === this.kontaktperson.id
          ? (this.wieKontaktperson = true)
          : (this.wieKontaktperson = false);
      },
    },
    kontaktperson: {
      handler(newVal) {
        this.gesetzlicheVertretung.id === newVal.id
          ? (this.wieKontaktperson = true)
          : (this.wieKontaktperson = false);
      },
    },
  },
  mounted() {},
  methods: {
    setGesetzlicheVertretungAufKontaktperson(bool) {
      if (bool) {
        this.setPerson(this.kontaktperson);
      } else {
        // Verbindung trennen
      }
    },

    setPerson(person) {
      AppApi.put(
        "relation/mit/",
        {},
        {
          params: {
            gpIdAlt: this.gesetzlicheVertretung.id,
            gpIdNeu: person.id,
            relationMitId: this.gpId,
            relationstypId: this.gesetzlicheVertretung.beziehung.id,
          },
        }
      )
        .then(() => {
          this.$emit("gpReload");
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: "Neue gesetzliche Vertretung erfolgreich verknüpft",
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });

      this.person = person;
    },
  },
};
</script>

<style></style>
